import React, { useEffect, useState, useRef } from 'react';
import { logEvent } from 'firebase/analytics';
import { getAnalytics } from 'firebase/analytics';
import app from '../services/firebase';

const AppStoreRedirect = () => {
  const analytics = getAnalytics(app);
  const APP_STORE_URL = 'https://apps.apple.com/us/app/food-recipes-chef-kats/id6739225693';
  const [isTikTok, setIsTikTok] = useState(false);
  const videoRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [buttonGlow] = useState(() => ({
    opacity: 0.3,
    scale: 1,
  }));

  useEffect(() => {
    // Детект TikTok браузера
    const userAgent = navigator.userAgent.toLowerCase();
    const isTikTokBrowser = userAgent.includes('tiktok') || userAgent.includes('bytedance');
    setIsTikTok(isTikTokBrowser);

    // Автоматический редирект для всех браузеров
    const autoRedirect = setTimeout(() => {
      window.location.href = APP_STORE_URL;
    }, 2500); // 2.5 секунды задержки

    // Очистка таймера при размонтировании
    const cleanup = () => clearTimeout(autoRedirect);

    // Трекинг первого визита
    const trackVisit = () => {
      try {
        // Firebase Analytics - четкие названия событий
        logEvent(analytics, 'TK_ROUTE_APP_STORE_REDIRECT', {
          source: 'tk_route',
          destination: 'app_store',
          timestamp: new Date().toISOString(),
          user_agent: navigator.userAgent,
          referrer: document.referrer,
          route: window.location.pathname,
          is_tiktok: isTikTokBrowser
        });
        
        // Счетчик TK переходов
        logEvent(analytics, 'TK_CLICK_COUNT', {
          destination: 'app_store',
          route: window.location.pathname,
          click_type: 'tk_redirect'
        });

        // Google Analytics gtag - четкие названия
        if (window.gtag) {
          // TK маршрут - основное событие
          window.gtag('event', 'TK_ROUTE_CLICK', {
            event_category: 'TK_MARKETING',
            event_action: 'App_Store_Redirect',
            event_label: 'TK_Route_To_AppStore',
            value: 1,
            custom_parameter_route: window.location.pathname
          });
          
          // TK конверсия
          window.gtag('event', 'TK_CONVERSION', {
            event_category: 'CONVERSIONS',
            event_action: 'TK_To_AppStore',
            event_label: 'TK_Success',
            value: 1
          });
          
          // TK счетчик
          window.gtag('event', 'TK_COUNT', {
            event_category: 'COUNTERS',
            event_action: 'TK_Click_Count',
            event_label: window.location.pathname,
            value: 1
          });
        }

        // Google Tag Manager - четкие события
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'TK_ROUTE_REDIRECT',
            event_category: 'TK_MARKETING',
            event_action: 'TK_App_Store_Redirect',
            event_label: 'TK_Route_Success',
            page_path: window.location.pathname,
            redirect_type: 'TK_TO_APPSTORE',
            redirect_count: 1
          });
          
          // TK счетчик для GTM
          window.dataLayer.push({
            event: 'TK_CLICK_COUNTER',
            category: 'TK_COUNTERS',
            action: 'TK_Route_Click',
            label: 'TK_' + window.location.pathname,
            tk_click: 1
          });
        }

        console.log('App Store redirect tracked successfully');
      } catch (error) {
        console.error('Error tracking app store redirect:', error);
      }
    };

    // Трек визита
    trackVisit();
    
    // Возвращаем функцию очистки
    return cleanup;
  }, [analytics]);

  const handleAppStoreClick = () => {
    // Дополнительный трекинг клика по ссылке
    if (window.gtag) {
      window.gtag('event', 'manual_app_store_click', {
        event_category: 'engagement',
        event_label: 'direct_app_store_click'
      });
    }
    // Открываем App Store
    window.open(APP_STORE_URL, '_blank');
  };

  const handleTryClick = () => {
    setShowModal(true);
    // Также сразу редиректим в App Store
    setTimeout(() => {
      window.location.href = APP_STORE_URL;
    }, 100);
  };

  return (
    <div className="app-store-redirect">
      {/* Top arrow only */}
      <div className="top-instruction">
        <div className="arrow-container">
          <img 
            src="/arrow.png" 
            alt="Arrow pointing to menu" 
            className="arrow-image"
          />
        </div>
      </div>

      {/* Instruction text above video */}
      <div className="top-instruction-text">
        <p className="top-instruction-main">
          Tap <span className="dots">⋯</span> and open in browser
        </p>
      </div>

      {/* Main content */}
      <div className="content-1">
        {/* Image container - styled like SurveyStep7 */}
        <div className="video-container">
          <img
            src="/24.png"
            alt="Chef Kats App"
            className="video"
          />
        </div>
      </div>

      {/* Bottom content */}
      <div className="bottom-content">
        {/* Text above button */}
        <h2 className="invite-text">
          We want to invite you to<br />Chef Kats for free
        </h2>

        {/* Button with glow effect */}
        <div className="button-wrapper">
          <div className="button-glow" />
          <button
            className="continue-button"
            onClick={handleTryClick}
          >
            Try for $0.00
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">How to open App Store</div>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="modal-arrow-illustration">
                <img src="/arrow.png" alt="Arrow" className="modal-arrow" />
              </div>
              <p className="modal-instruction">
                1. Tap the <span className="modal-dots">⋯</span> menu button<br/>
                2. Select "Open in Safari" or "Open in Browser"<br/>
                3. App Store will open automatically
              </p>
              <div className="modal-buttons">
                <button className="modal-button-secondary" onClick={() => setShowModal(false)}>
                  Got it
                </button>
                <button className="modal-button" onClick={handleAppStoreClick}>
                  Open Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .app-store-redirect {
          min-height: 100vh;
          background-color: #fff;
          padding-top: 20px;
          display: flex;
          flex-direction: column;
          font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif;
          overflow-x: hidden;
          position: relative;
        }

        .top-instruction {
          position: relative;
          padding: 10px 20px 5px 20px;
          z-index: 10;
        }

        .arrow-container {
          position: absolute;
          top: 5px;
          right: 15px;
          max-width: 300px;
        }

        .arrow-image {
          width: 120px;
          height: auto;
        }

        .top-instruction-text {
          text-align: center;
          margin: 20px auto;
          padding: 16px 20px;
          top: 60px !important;
          background-color: rgba(0, 0, 0, 0.9);
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          max-width: 280px;
          position: relative;
          z-index: 100;
        }

        .top-instruction-main {
          font-size: 16px;
          font-weight: 700;
          color: white;
          margin: 0;
          letter-spacing: -0.2px;
          line-height: 1.3;
        }

        .dots {
          color: white;
          font-weight: 700;
          font-size: 20px;
        }

        .content-1 {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 10px 24px 20px 24px;
        }

        .video-container {
          width: 100%;
          max-width: 350px;
          height: 350px;
          border-radius: 40px;
          margin-top: 50px !important;
          overflow: hidden;
          background-color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
           margin-top: 20px;
          position: relative;
        }

        .video {
          width: 100%;
          height: 100%;
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
        }

        .bottom-content {
          padding: 20px 24px 60px 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .invite-text {
          font-size: 26px;
          font-weight: 700;
          color: #19171D;
          text-align: center;
          margin: 0 0 32px 0;
          letter-spacing: -0.5px;
          line-height: 1.2;
        }

        .button-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }

        .button-glow {
          position: absolute;
          width: 340px;
          height: 80px;
          border-radius: 40px;
          background-color: rgba(0, 0, 0, 0.05);
          animation: glow 2s ease-in-out infinite alternate;
          z-index: 0;
        }

        .continue-button {
          width: 90%;
          max-width: 340px;
          height: 60px;
          border-radius: 16px;
          background-color: #000;
          border: none;
          color: #fff;
          font-size: 22px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          z-index: 1;
        }

        .continue-button:hover {
          background-color: #333;
          transform: translateY(-2px);
        }

        .continue-button:active {
          transform: translateY(0) scale(0.98);
        }


        @keyframes glow {
          0% {
            opacity: 0.3;
            transform: scale(1);
          }
          100% {
            opacity: 0.1;
            transform: scale(1.05);
          }
        }

        /* Mobile-only styles */
        .app-store-redirect {
          padding-top: 15px;
        }

        .top-instruction {
          padding: 5px 15px 5px 15px;
        }

        .instruction-text {
          margin-top: 16px;
          padding: 12px 16px;
          margin-left: 15px;
          margin-right: 15px;
          background-color: rgba(0, 0, 0, 0.8);
          color: white;
        }

        .instruction-main {
          font-size: 16px;
          color: white;
        }

        .dots {
          font-size: 18px;
          color: white;
        }

        .arrow-image {
          width: 100px;
        }

        .content-1 {
          padding: 10px 20px 15px 20px;
        }

        .video-container {
          max-width: 100%;
          height: 400px;
          margin-bottom: 16px;
          margin-top: 10px;
          transform: scale(1.1);
        }

        .bottom-content {
          padding: 15px 20px 50px 20px;
        }

        .invite-text {
          font-size: 22px;
          margin: 0 0 24px 0;
        }

        .continue-button {
          font-size: 18px;
          height: 50px;
        }

        .button-glow {
          width: 280px;
          height: 70px;
        }

        /* Modal styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.9));
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          backdrop-filter: blur(10px);
          animation: modalFadeIn 0.3s ease-out;
        }

        .modal-content {
          background: white;
          border-radius: 24px;
          padding: 0;
          max-width: 350px;
          width: 90%;
          position: relative;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          animation: modalSlideUp 0.3s ease-out;
        }

        .modal-header {
          padding: 20px 20px 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f0f0f0;
        }

        .modal-title {
          font-size: 20px;
          font-weight: 700;
          color: #000;
          margin: 0;
        }

        .modal-close {
          background: #f5f5f5;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          transition: all 0.2s ease;
        }

        .modal-close:hover {
          background: #e0e0e0;
          transform: scale(1.1);
        }

        .modal-body {
          padding: 20px;
          text-align: center;
        }

        .modal-arrow-illustration {
          margin: 10px 0 20px 0;
          display: flex;
          justify-content: center;
        }

        .modal-arrow {
          width: 80px;
          height: auto;
          opacity: 0.8;
        }

        .modal-instruction {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin: 0 0 30px 0;
          letter-spacing: -0.2px;
          line-height: 1.6;
          text-align: left;
        }

        .modal-dots {
          color: #007AFF;
          font-weight: 700;
          font-size: 18px;
          background: #e8f4ff;
          padding: 2px 6px;
          border-radius: 6px;
        }

        .modal-buttons {
          display: flex;
          gap: 12px;
        }

        .modal-button {
          flex: 1;
          height: 48px;
          border-radius: 16px;
          background: linear-gradient(135deg, #007AFF, #005BBB);
          border: none;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(0, 123, 255, 0.3);
        }

        .modal-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }

        .modal-button:active {
          transform: translateY(0) scale(0.98);
        }

        .modal-button-secondary {
          flex: 1;
          height: 48px;
          border-radius: 16px;
          background: #f5f5f5;
          border: none;
          color: #666;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .modal-button-secondary:hover {
          background: #e0e0e0;
          transform: translateY(-1px);
        }

        .modal-button-secondary:active {
          transform: translateY(0) scale(0.98);
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes modalSlideUp {
          from {
            opacity: 0;
            transform: translateY(50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default AppStoreRedirect;